module.exports = __webpack_public_path__ + "img/price-send-shipping.8c3a5aac.png";